<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.1442 4.03204C12.8526 1.32364 17.2708 1.33339 19.9694 4.03204C22.6768 6.73956 22.6768 11.1497 19.9694 13.8572L18.8223 15.0043C18.4317 15.3948 17.7986 15.3948 17.4081 15.0042C17.0176 14.6137 17.0176 13.9805 17.4081 13.59L18.5552 12.4431C18.5552 12.4431 18.5552 12.443 18.5552 12.4431C20.4815 10.5166 20.4816 7.37272 18.5552 5.44625C18.5552 5.44625 18.5552 5.44626 18.5552 5.44625M18.5552 5.44625C16.6358 3.52692 13.484 3.52066 11.5584 5.44625L10.4114 6.59326C10.0209 6.98379 9.38772 6.98379 8.9972 6.59327C8.60667 6.20274 8.60667 5.56958 8.99719 5.17905L10.1442 4.03204M15.3438 8.74636C15.7343 9.13688 15.7343 9.77005 15.3438 10.1606L10.1114 15.3929C9.72087 15.7834 9.08771 15.7834 8.69719 15.3929C8.30667 15.0023 8.30667 14.3692 8.6972 13.9786L13.9296 8.74634C14.3201 8.35582 14.9533 8.35583 15.3438 8.74636ZM6.59186 8.99635C6.98238 9.38687 6.98238 10.02 6.59186 10.4106L5.44486 11.5576C3.51838 13.484 3.51838 16.6279 5.44486 18.5544C7.36421 20.4737 10.516 20.48 12.4416 18.5544L13.5886 17.4073C13.9791 17.0168 14.6123 17.0168 15.0028 17.4073C15.3933 17.7979 15.3933 18.431 15.0028 18.8216L13.8558 19.9686C11.1474 22.677 6.72929 22.6672 4.03064 19.9686C1.32312 17.261 1.32312 12.8509 4.03064 10.1433L5.17764 8.99635C5.56817 8.60582 6.20133 8.60582 6.59186 8.99635Z"
      fill="currentColor"
    />
  </svg>
</template>

<script setup></script>
